var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useStripe, useElements, PaymentElement, } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import PageSubmitButton from '../molecules/PageSubmitButton';
import { useConfirm } from '../../hooks/confirmationHook';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 30px;\n  text-align: center;\n"], ["\n  margin-top: 30px;\n  text-align: center;\n"])));
var StripeCheckoutForm = function (_a) {
    var invoiceId = _a.invoiceId;
    var t = useTranslation().t;
    var confirm = useConfirm();
    var stripe = useStripe();
    var elements = useElements();
    var _b = React.useState(false), processing = _b[0], setProcessing = _b[1];
    var _c = React.useState(true), disabled = _c[0], setDisabled = _c[1];
    var _d = React.useState(), errorMessage = _d[0], setErrorMessage = _d[1];
    var handleChange = React.useCallback(function (event) {
        setDisabled(!event.complete);
    }, []);
    var handleSubmit = React.useCallback(function (event) {
        event.preventDefault();
        if (!stripe || !elements) {
            return;
        }
        confirm('', t('messages.stripeConfirmBody'), function () { return __awaiter(void 0, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setProcessing(true);
                        return [4 /*yield*/, stripe.confirmPayment({
                                elements: elements,
                                confirmParams: {
                                    return_url: "".concat(TYPICA_FRONTEND_URL, "/roaster/invoices/").concat(invoiceId, "/stripe_payment_result"),
                                },
                            })];
                    case 1:
                        error = (_a.sent()).error;
                        if (error) {
                            setErrorMessage(error.message);
                            setProcessing(false);
                        }
                        else {
                            setErrorMessage(undefined);
                            setProcessing(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    }, [t, confirm, elements, stripe, invoiceId]);
    return (React.createElement(Form, { onSubmit: handleSubmit },
        React.createElement(Grid, { container: true, spacing: 4 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PaymentElement, { options: {
                        wallets: {
                            applePay: 'never',
                            googlePay: 'never',
                        },
                    }, onChange: handleChange })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PageSubmitButton, { disabled: !stripe || processing || disabled }, t('buttons.stripePayment'))),
            errorMessage && (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "h4", color: "red" }, errorMessage))))));
};
export default StripeCheckoutForm;
var templateObject_1;
